<template>
  <div class="tenant-manage">
    <Card :bordered="false">
      <div slot="title">
        <Row>
          <Col :xs="24" :sm="24" :md="12" :lg="16">
            <Divider orientation="left">{{langMap.tenantManagement[lang]}}</Divider>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="8">
            <Form :label-width="80">
              <div class="des-cardTittle-box">
                <FormItem :label="langMap.tenantName[lang]" class="leftFlex">
                  <Input v-model.trim="searchName" :placeholder="langMap.tenantName[lang]"/>
                </FormItem>
                <Button type="info" style="margin-left:20px;" @click="searchData">{{langMap.search[lang]}}</Button>
                <Button type="primary" style="margin-left:20px;" @click="openAddModal">{{langMap.addTenant[lang]}}</Button>
              </div>
            </Form>
          </Col>
        </Row>
      </div>

      <Table :height="height" :loading="tableLoading" border :columns="tenantColumns" :data="tenantList"></Table>

      <div style="text-align:center;padding-top:10px;" v-if="tenantList.length>0">
        <Page :current="index" :total="total" :page-size="15" @on-change="goPageData"></Page>
      </div>
    </Card>

    <!-- 新增租户模态框 -->
    <Modal :mask-closable="false" :title="modalTitle" v-model="tenantModal" width="500">
      <Form ref="tenantForm" :model="isEdit ? editForm : addForm" :rules="formRules" :label-width="100">
        <FormItem :label="langMap.tenantName[lang] + ':'" prop="name">
          <Input type="text" v-model="isEdit ? editForm.name : addForm.name" :placeholder="langMap.tenantName[lang]" @on-change="(val) => handleInputChange('name', val)" />
        </FormItem>
        <template v-if="!isEdit">
          <FormItem :label="langMap.adminCode[lang] + ':'" prop="adminCode">
            <Input type="text" v-model="addForm.adminCode" :placeholder="langMap.adminCodeRequired[lang]" />
          </FormItem>
          <FormItem :label="langMap.adminName[lang] + ':'" prop="adminName">
            <Input type="text" v-model="addForm.adminName" :placeholder="langMap.adminNameRequired[lang]"  />
          </FormItem>
          <FormItem :label="langMap.adminPhone[lang] + ':'" prop="adminPhone">
            <Input type="text" v-model="addForm.adminPhone" :placeholder="langMap.adminPhoneRequired[lang]"  />
          </FormItem>
          <FormItem :label="langMap.adminEmail[lang] + ':'" prop="adminEmail">
            <Input type="email" v-model="addForm.adminEmail" :placeholder="langMap.adminEmailRequired[lang]" autocomplete="new-email" />
          </FormItem>
          <FormItem :label="langMap.adminPwd[lang] + ':'" prop="adminPwd">
            <Input type="password" v-model="addForm.adminPwd" :placeholder="langMap.adminPwdRequired[lang]" autocomplete="new-password" />
          </FormItem>
        </template>
      </Form>
      <div slot="footer">
        <Button @click="tenantModal = false" style="margin-left: 8px">{{langMap.cancel[lang]}}</Button>
        <Button @click="saveTenant" type="primary">{{langMap.save[lang]}}</Button>
      </div>
    </Modal>

    <!-- 查看用户列表模态框 -->
    <Modal v-model="userListModal" :title="langMap.userList[lang]" width="500">
      <Table :columns="userColumns" :data="userList"></Table>
      <div style="text-align:center;padding-top:10px;" v-if="userList.length>0">
        <Page :current="userIndex" :total="userTotal" :page-size="15" @on-change="goUserPage"></Page>
      </div>
    </Modal>

  </div>
</template>

<script>
import api from "@/api"
import langMap from '@/utils/language'
import { mapState } from 'vuex'
import { validatePassword, createValidator } from '@/utils/validators'
var md5 = require("js-md5");

export default {
  data() {
    return {
      langMap: langMap,
      height: document.documentElement.clientHeight - 300,
      tableLoading: false,

      // 搜索条件
      searchCode: "",
      searchName: "",
      index: 1,
      total: 0,
      routeSearchState: {
        tenant: {
          searchName: "",
          index: 1
        },
        tenantOnly: {
          searchName: "",
          index: 1
        }
      },

      // 租户列表
      tenantList: [],

      // 新增/编辑表单
      tenantModal: false,
      modalTitle: "",
      isEdit: false,

      // 新增表单
      addForm: {
        name: "",
        adminPhone: "",
        adminCode: "",
        adminName: "",
        adminEmail: "",
        adminPwd: ""
      },

      // 编辑表单
      editForm: {
        id: "",
        name: ""
      },

      // 用户列表
      userListModal: false,
      userList: [],
      userIndex: 1,
      userTotal: 0,
      currentTenantId: null

    }
  },

  computed: {
    ...mapState({
      lang: state => state.app.language
    }),
    isOnlyMine() {
      return this.$route && this.$route.name === "tenantOnly"
    },

    tenantColumns() {
      return [
        // {
        //   title: "#",
        //   width: 80,
        //   type: "index"
        // },
        {
          title: this.langMap.tenantCode[this.lang],
          key: "id",
          minWidth: 120
        },
        {
          title: this.langMap.tenantName[this.lang],
          key: "name",
          minWidth: 120
        },
        {
          title: this.langMap.createTime[this.lang],
          key: "createTime",
          minWidth: 150
        },
        {
          title: this.langMap.status[this.lang],
          minWidth: 120,
          render: (h, params) => {
            return h("span", params.row.state === 0 ? this.langMap.normal[this.lang] : this.langMap.freeze[this.lang])
          }
        },
        {
          title: this.langMap.operation[this.lang],
          width: 300,
          align: "center",
          render: (h, params) => {
            const state = params.row.state
            return h("div", [
              h("Button", {
                props: {
                  type: "text",
                  size: "small"
                },
                style: {
                  color: "#2d8cf0"
                },
                on: {
                  click: () => {
                    this.changeTenantStatus(params.row)
                  }
                }
              }, state === 0 ? this.langMap.disable[this.lang] : this.langMap.enable[this.lang]),
              h("Divider", {
                props: {
                  type: "vertical"
                }
              }),
              h("Button", {
                props: {
                  type: "text",
                  size: "small"
                },
                style: {
                  color: "#2d8cf0"
                },
                on: {
                  click: () => {
                    this.editTenant(params.row)
                  }
                }
              }, this.langMap.modifyInfo[this.lang]),
              h("Divider", {
                props: {
                  type: "vertical"
                }
              }),
              h("Button", {
                props: {
                  type: "text",
                  size: "small"
                },
                style: {
                  color: "#2d8cf0"
                },
                on: {
                  click: () => {
                    this.viewUsers(params.row.id)
                  }
                }
              }, this.langMap.viewUsers[this.lang])
            ])
          }
        }
      ]
    },

    // 表单校验规则
    formRules() {
      const baseRules = {
        name: [
          { required: true, message: langMap.tenantNameRequired[this.lang], trigger: "blur" }
        ]
      }

      if (!this.isEdit) {
        return {
          ...baseRules,
          adminPhone: [{ required: true, message: langMap.adminPhoneRequired[this.lang], trigger: "blur" }],
          adminCode: [{ required: true, message: langMap.adminCodeRequired[this.lang], trigger: "blur" }],
          adminName: [{ required: true, message: langMap.adminNameRequired[this.lang], trigger: "blur" }],
          adminEmail: [
            { required: true, message: langMap.adminEmailRequired[this.lang], trigger: "blur" },
            { type: 'email', message: langMap.emailFormatError[this.lang], trigger: "blur" }
          ],
          adminPwd: [
            { required: true, message: langMap.adminPwdRequired[this.lang], trigger: "blur" },
            { max: 15, message: langMap.maxFifteenChar[this.lang], trigger: 'blur' },
            { validator: createValidator(validatePassword, this.lang), trigger: "blur" }
          ]
        }
      }

      return baseRules
    },
    userColumns() {
      return [
        {
          title: this.langMap.account[this.lang],
          key: 'code',
          minWidth: 120
        },
        {
          title: this.langMap.username[this.lang],
          key: 'name',
          minWidth: 120
        },
        {
          title: this.langMap.roleName[this.lang],
          key: 'roleName',
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              params.row.roleName ? params.row.roleName : this.langMap.noRole[this.lang]
            );
          }
        }
      ]
    }
  },

  methods: {
    isTenantRoute(routeName) {
      return routeName === "tenant" || routeName === "tenantOnly"
    },
    saveSearchStateByRoute(routeName) {
      if (!this.isTenantRoute(routeName)) return
      this.routeSearchState[routeName] = {
        searchName: this.searchName,
        index: this.index
      }
    },
    restoreSearchStateByRoute(routeName) {
      if (!this.isTenantRoute(routeName)) return
      const currentState = this.routeSearchState[routeName]
      this.searchName = currentState.searchName
      this.index = currentState.index
    },
    // 查看用户列表
    viewUsers(tenantId) {
      this.currentTenantId = tenantId
      this.userIndex = 1
      this.getUserList()
    },

    // 获取用户列表
    getUserList() {
      api.getData(`system-server/user/userListByTenantIdPage/${this.currentTenantId}?index=${this.userIndex}&size=10`, this).then(res => {
        if (res.state === 0) {
          this.$Notice.error({
            title: this.langMap.tip[this.lang],
            desc: res.msg
          })
        } else {
          this.userList = res.data.rows.map(user => ({
            code: user.code,
            name: user.name,
            roleName: user.roleName
          }))
          this.userTotal = res.data.total
          this.userListModal = true
        }
      })
    },

    // 用户列表分页
    goUserPage(index) {
      this.userIndex = index
      this.getUserList()
    },

    // 处理输入框变化
    handleInputChange(field, event) {
      const value = event.target.value
      if (this.isEdit) {
        this.editForm[field] = value
      } else {
        this.addForm[field] = value
      }
    },

    // 获取租户列表
    getTenantList() {
      this.tableLoading = true
      const onlyMineQuery = this.isOnlyMine ? "&onlyMine=true" : ""
      api.getData(`system-server/tenant/page?index=${this.index}&name=${this.searchName}${onlyMineQuery}`, this).then(res => {
        if (res.state === 0) {
          this.$Notice.error({
            title: this.langMap.tip[this.lang],
            desc: res.msg
          })
        } else {
          this.total = res.data.total
          this.tenantList = res.data.rows
        }
        this.tableLoading = false
      })
    },

    // 搜索
    searchData() {
      this.index = 1
      this.getTenantList()
    },

    // 分页
    goPageData(index) {
      this.index = index
      this.getTenantList()
    },

    // 打开新增模态框
    openAddModal() {
      this.$refs.tenantForm && this.$refs.tenantForm.resetFields()
      this.isEdit = false
      this.addForm = {
        name: "",
        adminPhone: "",
        adminCode: "",
        adminName: "",
        adminEmail: "",
        adminPwd: ""
      }
      this.modalTitle = this.langMap.addTenant[this.lang]
      this.tenantModal = true
      this.$nextTick(() => {
        if (this.$refs.tenantForm) {
          this.$refs.tenantForm.clearValidate()
        }
      })
    },

    // 编辑租户
    editTenant(row) {
      this.$refs.tenantForm && this.$refs.tenantForm.resetFields()
      this.isEdit = true
      this.editForm = {
        id: row.id,
        name: row.name
      }
      this.modalTitle = this.langMap.modifyInfo[this.lang]
      this.tenantModal = true
    },

    // 保存租户
    saveTenant() {
      this.$refs.tenantForm.validate(valid => {
        if (valid) {
          const formData = this.isEdit ? { ...this.editForm } : { ...this.addForm }
          const url = this.isEdit ? 'system-server/tenant/update/info' : 'system-server/tenant/save'

          if (!this.isEdit) {
            formData.adminPwd = md5(formData.adminPwd)
          }

          this.$Spin.show()
          api.postData(url, formData, this).then(res => {
            if (res.state === 0) {
              this.$Notice.error({
                title: this.langMap.tip[this.lang],
                desc: res.msg
              })
            } else {
              this.$Notice.success({
                title: this.langMap.tip[this.lang],
                desc: this.langMap.saveSuccess[this.lang]
              })
              this.tenantModal = false
              this.getTenantList()
            }
            this.$Spin.hide()
          })
        }
      })
    },

    // 修改租户状态
    changeTenantStatus(row) {
      this.$Modal.confirm({
        title: this.langMap.tip[this.lang],
        content: this.langMap.confirmModifyTenantStatus[this.lang],
        onOk: () => {
          this.$Spin.show()
          api.getData(`system-server/tenant/updateState?id=${row.id}`, this).then(res => {
            if (res.state === 0) {
              this.$Notice.error({
                title: this.langMap.tip[this.lang],
                desc: res.msg
              })
            } else {
              this.getTenantList()
            }
            this.$Spin.hide()
          })
        }
      })
    },

    // 单个字段校验
    validateField(field) {
      this.$refs.tenantForm.validateField(field)
    },


  },
  watch: {
    $route(to, from) {
      this.saveSearchStateByRoute(from.name)
      this.restoreSearchStateByRoute(to.name)
      if (this.isTenantRoute(to.name)) {
        this.getTenantList()
      }
    }
  },

  created() {
    this.restoreSearchStateByRoute(this.$route.name)
    this.getTenantList()
  }
}
</script>

<style lang="less">
.tenant-manage {
  .des-cardTittle-box {
    display: flex;
    align-items: center;
  }
  .leftFlex {
    margin-right: 10px;
  }
}
</style>
